var jsCollection = (function($, window, History){

  var o = {};
  o = {
    navbarExpand: false
  }

  // product filter
  var PF = {};
  PF = {
    $scope: $('#productFilter'),
    $tasks: $('#productFilter #pftTasks'),
    init: function() {
      var self = this;

      self.clicks = false;
      self.events();
      self.collectArr();
      self.tasks()
      self.stickybar();

      History.Adapter.bind(window, 'statechange', function(){
        if(!self.clicks) {
          var loc = History.getState();
          PF.ajx(loc.url);
        }
        self.clicks = false;
      })

    },
    events: function() {
      var self = this;
      // tag list
      PF.$scope.on('click', '.tag-list > li', function(ev) {
        ev.stopPropagation();

        var et = ev.target;
        var dataSelect = $(et).attr('data-select');
        var t = document.querySelectorAll('.tag-list > li');
        var tags = Array.prototype.slice.call(t);
        var v = document.querySelector('.tag-vendor-list');
        var vendor = v.getAttribute('data-vendorselect')
        var group = document.getElementById('pftg');
        var clear = document.querySelector('.pft-clear')
        var arr = [];
        var reg = /[1]/i;

        if (dataSelect === '0') {
          $(et).attr('data-select', '1');
        } else if(dataSelect === '1') {
          $(et).attr('data-select', '0');
        }

        tags.forEach(function(el, idx) {
          var check = el.getAttribute('data-select');
          arr.push(check)
        });

        var out = arr.join('').search(reg);
        if(out === -1 ) {
          group.setAttribute('data-selected', '0');
          if (vendor === '0') {
            clear.setAttribute('data-enable', '0');
          }
        } else {
          group.setAttribute('data-selected', '1');
          clear.setAttribute('data-enable', '1');
        }
      });

      // vendor list
      PF.$scope.on('click', '.tag-vendor-list > li', function(ev) {
        ev.stopPropagation();

        var et = ev.target;
        var dataSelect = $(et).attr('data-select');
        var $vendor = $('#productFilter .tag-vendor-list > li');
        var clear = document.querySelector('.pft-clear');
        var group = document.getElementById('pftg');
        var groupSelected = group.getAttribute('data-selected');

        $vendor.each(function(idx, el){
          var vendorList = $('#productFilter .tag-vendor-list');
          vendorList.attr('data-vendorselect', '1');
          clear.setAttribute('data-enable', '1');
          $(et).attr('data-select', '1');
          if(dataSelect === '1') {
            $(et).attr('data-select', '0')
            vendorList.attr('data-vendorselect', '0')
            if(groupSelected === '0') {
              clear.setAttribute('data-enable', '0');
            }
          }
          if( $(el).attr('data-select') === '1') {
            $(el).attr('data-select', '0');
          }
        })
      });

      // sort list
      PF.$scope.on('click', '.sort-list > li > a', function(ev) {
        ev.stopPropagation();
        ev.preventDefault();

        var loca = window.location;
        var loc;
        var et = ev.target;
        var evVal = et.getAttribute('data-value')
        var listing = document.querySelector('#pfs .sort-list');
        var currTags = listing.getAttribute('data-currtags');
        var currVen = listing.getAttribute('data-currvend');

        if (currTags !== "0") {
          loc = loc = loca.protocol + '//' + loca.hostname + loca.pathname + '?constraint=' + currTags + '&sort_by=' + evVal;
          if (currVen !== "0") {
            loc = loc = loca.protocol + '//' + loca.hostname + loca.pathname + '?q=' + currVen + '&constraint=' + currTags + '&sort_by=' + evVal;
          }
        } else if (currVen !== "0"){
          loc = loc = loca.protocol + '//' + loca.hostname + loca.pathname + '?q=' + currVen + '&sort_by=' + evVal;
        } else {
          loc = loc = loca.protocol + '//' + loca.hostname + loca.pathname + '?sort_by=' + evVal;
        }
        setTimeout(function(){
          PF.ajx(loc);
        }, 300);

        self.clicks = true;
      });
    },
    collectArr: function() {
      var self = this;
      PF.$tasks.on('click', '.pft-apply', function(ev) {
        var arr = [];
        var wloc = window.location;
        var loc;
        var t;
        var v;
        var st = 0;
        var tagData = $('#pftg li[data-select]');
        var e = document.getElementById('pft');
        e.setAttribute('data-expand', '0');
        jsCollection.navbarExpand = false;

        tagData.each( function(idx, el) {
          var elSelect = $(el).attr('data-select');

          if (elSelect === '1') {
            t = $(el).attr('data-tags');
            v = $(el).attr('data-vendor');
            arr.push(t);
          }
        });

        var tags = arr.toString().replace(/\,/g, '+');

        var vList = $('#productFilter .tag-vendor-list');
        var vSelect = vList.attr('data-vendorselect');
        var vCurr = vList.attr('data-vendorcurrent');
        var ven = vList.attr('data-vend');

        if (vSelect === '0') {
          if (tags) {
            loc = wloc.protocol + '//' + wloc.hostname + wloc.pathname + '?constraint=' + tags
          } else {
            loc = wloc.protocol + '//' + wloc.hostname + wloc.pathname
          }
          if(vCurr === '1' && tags) {
            loc = wloc.protocol + '//' + wloc.hostname + '/collections/all?constraint=' + tags
          } else if (vCurr === '1' && !tags) {
            loc = wloc.protocol + '//' + wloc.hostname + wloc.pathname + '?q=' + ven
          }
        } else if (vSelect === '1') {
          if (tags) {
            loc = wloc.protocol + '//' + wloc.hostname + '/collections/' + v + '&constraint=' + tags
          } else {
            loc = wloc.protocol + '//' + wloc.hostname + '/collections/' + v
          }
        }
        setTimeout(function(){
          PF.ajx(loc);
        }, 300);
        
        self.clicks = true;
      })
    },
    ajx: function(loc) {

      var collHead = document.getElementById('copHeader');
      var collHeadHeigth = collHead.getBoundingClientRect().height;
      var cover = document.getElementById('copContainerCover');

      if (typeof history.pushState === 'undefined') {
        window.location = loc
      } else {
        $.ajax({
          type: 'get',
          url: loc,
          dataType: 'html',
          beforeSend: function() {
            console.log('filter wait....');
            cover.setAttribute('data-cover', '1')
          },
          success: function(data){
            document.body.scrollTop = collHeadHeigth;
            cover.setAttribute('data-cover', '0')
            PF.buildContent(data);
            Currency.convertAll('USD', $('#currencies').val(), 'span.money', 'money_format');
            window.SPR.registerCallbacks();
            window.SPR.initRatingHandler();
            window.SPR.initDomEls();
            window.SPR.loadProducts();
            window.SPR.loadBadges();
            IN.init()
            console.log('filter success...')
          },
          error: function(xhr, txt) {
            var mes = $.parseJSON(xhr.responseText).description;
            console.log(mes);
            console.log('filter error...')
          }
        });

        var title = document.title;
        History.pushState(null, title, loc)
      }

    },
    buildContent: function(data) {
      var $data = $(data);

      var prod = $('#productList');
      var newProd = $data.find('#productList');
      prod.replaceWith(newProd)

      var tags = $('#pftg');
      var newTags = $data.find('#pftg');
      tags.replaceWith(newTags);

      var butt = $('#tasksReplace');
      var newButt = $data.find('#tasksReplace');
      butt.replaceWith(newButt)

      var coll = $('#pfcReplace');
      var newColl = $data.find('#pfcReplace');
      coll.replaceWith(newColl);

      var type = $('.pfc-type');
      var newType = $data.find('.pfc-type');
      type.replaceWith(newType)

      var sort = $('#pfsReplace');
      var sortType = $('.pfs-type');
      var newSort = $data.find('#pfsReplace');
      var newSortType = $data.find('.pfs-type');
      sort.replaceWith(newSort);
      sortType.replaceWith(newSortType);

      var pagin = $('#copPaginateReplace');
      var newPagin = $data.find('#copPaginateReplace');
      pagin.replaceWith(newPagin);

    },
    tasks: function() {
      var self = this;

      // clearing
      PF.$tasks.on('click', '.pft-clear', function(ev) {
        ev.preventDefault();
        var t = document.querySelectorAll('#pftg li[data-select]');
        var allTags = Array.prototype.slice.call(t);
        var vend = document.querySelector('.tag-vendor-list')
        var selected = document.getElementById('pftg');
        allTags.forEach(function(el, idx) {
          el.setAttribute('data-select', '0');
        });
        vend.setAttribute('data-vendorselect', '0')
        ev.target.setAttribute('data-enable', '0')
        selected.setAttribute('data-selected', '0')
      })

      // canceling
      var scpe = document.getElementById('pft')
      PF.$scope.on('click', '.pft-cancel', function(ev) {
        ev.stopPropagation();
        if (jsCollection.navbarExpand) {
          scpe.setAttribute('data-expand', '0');
          jsCollection.navbarExpand = false;
        }
      });

      // small screen expand filter
      PF.$scope.on('click', '#pftg>.tag-item>h5', function(ev) {
        ev.preventDefault();
        
        var et = ev.target;
        var parent = et.parentNode;
        var isExpand = parent.getAttribute('data-mobileexpand');

        if (isExpand === '0') {
          parent.setAttribute('data-mobileexpand', '1')
        } else {
          parent.setAttribute('data-mobileexpand', '0')
        }
      })
    },
    stickybar: function() {
      function s() {
        var prodContent = document.getElementById('copContainer');
        var filterBar = document.getElementById('productFilter');
        var isSticky = filterBar.getAttribute('data-sticky');
        var listing = document.getElementById('productList');
        var copHeader = document.getElementById('copHeader')
        var prodContentTop = prodContent.getBoundingClientRect().top;
        
        if (prodContentTop <= 50) {
          filterBar.setAttribute('data-sticky', '1')
          listing.style.minHeight = 450 + 'px';
          copHeader.style.marginBottom = 53 + 'px';
        } else {
          filterBar.setAttribute('data-sticky', '0');
          listing.removeAttribute('style');
          copHeader.removeAttribute('style');
        }

      }
      if (!jsGlobal.mediumScreen) {
        s();
        window.addEventListener('scroll', function(ev) {
          ev.stopPropagation();
          s();
        })
      }
    }
  }

  var navbar = {};
  navbar = {
    scope: ['#pfc', '#pft', '#pfs'],
    $filter: $('#productFilter'),
    pfc: document.getElementById('pfc'),
    pfs: document.getElementById('pfs'),
    init: function() {
      var self = this;

      self.expand();
      self.tasks();
    },
    expand: function() {
      var self = this;
      var productCover = document.getElementById('copContainerCover')
      self.fil = document.querySelectorAll(self.scope);
      self.fils = Array.prototype.slice.call(self.fil);

      self.fils.forEach(function(el, idx) {
        var trigger = el.querySelector('.pf-target')
        var i = self.fils.indexOf(el);

        var hide = function(current) {
          var current = current || self.fil[i];
          el.setAttribute('data-expand', '0');
          jsCollection.navbarExpand = false;
        }
        var hideAll = function() {
          self.current = -1;
          jsCollection.navbarExpand = false;
        }
        var hideGlobal = function() {
          document.addEventListener('click', function(ev) {
          ev.stopPropagation();

            if ( !jsGlobal.hasParent( ev.target, 'pfc')&&!jsGlobal.hasParent( ev.target, 'pft')&&!jsGlobal.hasParent( ev.target, 'pfs') ) {
              el.setAttribute('data-expand', '0');
              jsCollection.navbarExpand = false;
            }
          })
        }

        

        trigger.addEventListener('click', function(ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var ex = el.getAttribute('data-expand')

          // if(el) {
            if(ex === '1') {
              hide(el)
              hideAll();
            } else {
              if(self.current !== -1) {
                hide();
                $(self.fils).attr('data-expand', '0');
              }
              self.current = i;
              el.setAttribute('data-expand', '1');
              jsCollection.navbarExpand = true;
            }
            console.log(self.current)
          // } else {
          //   if(self.current !== -1) {
          //     hide();
          //     hideAll();
          //   }
          // }
          if(jsCollection.navbarExpand) {
            hideGlobal();
          }
        });
      })
    },
    tasks: function() {
      var self = this;

      self.btnType = self.pfc.querySelector('.pfc-type');
      self.sortType = self.pfs.querySelector('.pfs-type');

      self.$filter.on('click','.pfc-content a', function(ev) {
        ev.stopPropagation();

        var type = ev.target.childNodes[0].textContent;
        self.btnType.textContent = type;
        self.pfc.setAttribute('data-expand', '0');
        jsCollection.navbarExpand = false
      });

      self.$filter.on('click', '.pfs-content a', function(ev) {
        ev.stopPropagation();

        var type = ev.target.textContent;
        self.sortType.textContent = type;
        self.pfs.setAttribute('data-expand', '0');
        jsCollection.navbarExpand = false;
      })
    }
  }

  // infinite scroll
  var IN = {},
  IN = {
    init: function() {
      var loader = document.getElementById('paginateLoaderImg')
      
      var infinite = new Waypoint.Infinite({
        element: $('#productList'),
        items: '.product-item',
        more: '.cop-paginate-next',
        onBeforePageLoad: beforeCB,
        onAfterPageLoad: afterCB
      })

      function beforeCB() {
        if(loader) {
          loader.setAttribute('data-loader', '1')
        }
      }

      function afterCB(items) {
        if(loader) {
          loader.setAttribute('data-loader', '0')
        }
        Currency.convertAll('USD', $('#currencies').val(), 'span.money', 'money_format');
        window.SPR.registerCallbacks();
        window.SPR.initRatingHandler();
        window.SPR.initDomEls();
        window.SPR.loadProducts();
        window.SPR.loadBadges();
      }
    }
  }

  PF.init();
  navbar.init();
  IN.init();

  var $scope = $('#copContainer');
  var templ = document.getElementById('quickView');
  new emQuick($scope, templ);

  var $wishScope = $('#copContainer');
  new emWish($wishScope)

  return o;

})(jQuery, window, History);